import React from "react";
import inventory from "../assets/inventory.png";
import stores from "../assets/stores.png";
import dropers from "../assets/dropers-list.png";
import dashboard from "../assets/dashboard.png";
import settings from "../assets/settings.png";
import droperDetail from "../assets/droper-detail.png";
import orders from "../assets/orders.png";
import routes from "../assets/route-detail.png";
import reports from "../assets/reports.png";

const ProductOverview = () => {
    const features = [
        {
            title: "Comprehensive Dashboard Insights",
            description: "Gain valuable insights with real-time tracking of routes, orders, sales, and revenue. The dashboard includes low-stock and out-of-stock alerts.",
            imageUrl: dashboard,
        },
        {
            title: "Track Your Inventory Seamlessly",
            description: "Monitor stock levels, batch details, and expiration dates in real-time. Ensure your inventory is always up-to-date and accurate.",
            imageUrl: inventory,
        },
        {
            title: "Effortless Customer Management",
            description: "Manage your customers with ease. INVETIX allows you to group customers into routes and track their orders efficiently.",
            imageUrl: stores,
        },
        {
            title: "Order Management by Droppers and Admins",
            description: "Both droppers and admins can create orders directly from their applications. Droppers can create orders for customers, and admins can review, approve, or reject these orders based on requirements.",
            imageUrl: orders, // Dummy image URL
        },
        {
            title: "Route Creation and Assignment",
            description: "Admins can create routes, add stores or customers along with their ordered products, and assign these routes to droppers for efficient order fulfillment.",
            imageUrl: routes, // Dummy image URL
        },
        {
            title: "Empower Your Team with DROPIX",
            description: "Assign routes and delivery tasks to your dropers. With DROPIX, your delivery staff can access their schedules and update statuses in real-time.",
            imageUrl: dropers,
        },
        {
            title: "Live Track Your Droper",
            description: "Enhance transparency with live tracking of your droper's location as they deliver products to customers along their assigned routes. Stay informed about delivery progress in real-time.",
            imageUrl: droperDetail,
        },
        {
            title: "Analyze Your Business with Powerful Reports",
            description: "Gain valuable insights into sales, revenue, and product performance. Generate detailed reports to make data-driven decisions and optimize your business strategy.",
            imageUrl: reports,
        },
        {
            title: "Customizable Settings",
            description: "Configure your organization details, upload your logo, choose print preferences, and set GST configurations for smooth billing.",
            imageUrl: settings,
        },

    ];

    return (
        <section id="features" className="py-12  overflow-hidden">
            <div
                className="container mx-auto px-4 mt-8"
                data-aos="fade-up"
                data-aos-duration="2000"
            >
                <h2 className="text-3xl font-bold text-navy text-center">
                    Explore the Power of INVETIX Features
                </h2>

                <div className="mt-8 space-y-12">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className={`flex flex-col md:flex-row items-center ${index % 2 === 0
                                ? "md:flex-row"
                                : "md:flex-row-reverse"
                                } gap-8 md:py-12`}
                            data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
                        // data-aos-delay="200"
                        >
                            {/* Image Section */}
                            <div className="w-full md:w-8/12">
                                <img
                                    src={feature.imageUrl}
                                    alt={feature.title}
                                    className="rounded-lg  w-full h-auto"
                                    data-aos="zoom-in"
                                // data-aos-delay="400"
                                />
                            </div>

                            {/* Description Section */}
                            <div className="w-full md:w-4/12">
                                <h3
                                    className="text-2xl font-bold text-navy"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    {feature.title}
                                </h3>
                                <p
                                    className="text-gray-700 mt-4"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    {feature.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProductOverview;
